
import { defineComponent } from 'vue'
import { getIssueTypeIcon, getIssueTypeLabel } from '~/utils/ui'

export default defineComponent({
  name: 'IssueType',
  props: {
    issueType: {
      type: String,
      default: ''
    }
  },
  computed: {
    label(): string {
      return getIssueTypeLabel(this.issueType)
    },
    icon(): string {
      return getIssueTypeIcon(this.issueType)
    }
  }
})
